import '../../common/bn-property';
import { LitEntity, html, renderIf } from '../../utility/lit-entity';
import { formatDateTimeLong } from '../../utility/dates';

class WorkOrderDetails extends LitEntity {
  render() {
    return html`
      <bn-property label="Reference ID">${this.getProperty('referenceId')}</bn-property>
      <bn-property label="Type">${this.getProperty('requestType')}</bn-property>
      <bn-property label="State">${this.getProperty('state')}</bn-property>
      <bn-property label="Created">${formatDateTimeLong(this.getProperty('createdAt'))}</bn-property>
      ${renderIf(this.getProperty('preDiagnosis'), () => html`
        <bn-property label="Pre Diagnosis">${this.getProperty('preDiagnosis')}</bn-property>
      `)}
      ${renderIf(this.getProperty('instructions'), () => html`
        <bn-property label="Instructions">${this.getProperty('instructions')}</bn-property>
      `)}
    `;
  }
}

customElements.define('work-order-details', WorkOrderDetails);
